<template>
  <a-card>
    <a-alert type="info" showIcon class="table-alert" v-if="selectedRowKeys.length">
      <template #message>
        已选择 {{ selectedRowKeys.length }} 项
        <a @click="onClearSelected" class="ml-20 float-right">清空</a>
      </template>
    </a-alert>
    <a-table :columns="columns" :row-selection="{ selectedRowKeys: selectedRowKeys, onChange: onSelectChange }"
      :pagination="pagination" :data-source="dataSource" :loading="loading" @change="onTableChange">
      <template #name="{ record }">
        <a @click="onJobDetail(record)">{{ record.name }} </a>
      </template>
      <template #jobTitleExpectation="{ record }">
        <dict-render :dict-obj="dictObjs['hope_job']" :text="record.jobTitleExpectation"></dict-render>
      </template>
      <template #industry="{ text }">
        <dict-render :dict-obj="dictObjs['research_field']" :text="text"></dict-render>
      </template>
      <template #salary="{ text }">
        <dict-render :dict-obj="dictObjs['salary']" :text="text"></dict-render>
      </template>
      <template #stateWork="{ text }">
        <dict-render :dict-obj="dictObjs['work_status']" :text="text"></dict-render>
      </template>
      <template #action="{ record }">
        <div class="table-row-operations">
          <a @click="onEdit(record)">编辑</a>
        </div>
      </template>
    </a-table>
  </a-card>
  <DetailModal ref="detailModal" :form-primary-key-field="listKeyField" @finish="onFormEdited" />
</template>

<script>
import DetailModal from './components/DetailModal';
import { dictMixin, tableListMixin } from "@/mixins";
import { companyInvitedInfo, employmentIntentionInfo } from "@/api/educationService";
import DictRender from "@/components/other/DictRender";
import { dateFormat } from "@/config/variableConfig";
import { showCity } from "@/utils/util";

const columns = [
  // {title: "#", dataIndex: "index", key: "index", slots: {customRender: "index"}},
  { title: "姓名", dataIndex: "name", key: "name", slots: { customRender: "name" } },
  { title: "期望职位", dataIndex: "jobTitleExpectation", key: "jobTitleExpectation", slots: { customRender: "jobTitleExpectation" } },
  { title: "期望从事行业", dataIndex: "businessExpectation", key: "businessExpectation", slots: { customRender: "industry" } },
  { title: '期望薪资', dataIndex: "salaryExpectation", key: "salaryExpectation", slots: { customRender: "salary" } },
  { title: '工作状态', dataIndex: "stateWork", key: "stateWork", slots: { customRender: "stateWork" } },
  // { title: "操作", dataIndex: "action", key: "action", slots: { customRender: "action" } },
];
export default {
  name: "index",
  mixins: [tableListMixin, dictMixin],
  components: {
    DetailModal, DictRender
  },
  data() {
    return {
      dateFormat,
      dictNames: 'research_field,education_background,salary,work_status,hope_job',
      columns,
      queryParamFixed: { type: 0},
      listUrl: companyInvitedInfo.pageList,
      listKeyField: "id",
    }
  },
  methods: {
    onJobDetail(record) {
      this.getAction({
        url: employmentIntentionInfo.detail,
        params: { userId: record.userId }
      }).then(res => {
        let obj = {
          ...res,
          provject: showCity(res.prov, res.city, res.dist)
        }
        this.onShowModal('detailModal', obj);
      })
    }
  }
}
</script>

<style scoped></style>
